import {backendFetch} from "./NfBackendFetch";

export function getFirstAvailableTerm(widgetId:number, parameters: FirstAvailableTermParameters): Promise<FirstAvailableTermResult> {
    return backendFetch(widgetId, 'get_first_period', 'POST','application/json',JSON.stringify(parameters)).then(response => response.json());
}

export interface FirstAvailableTermResult {
    first_from_date: string|null;
    first_to_date: string|null;
}
export interface FirstAvailableTermParameters {

    /**
     * ilość dorosłych
     */
    adult_count?: number;
    /**
     * Wiek dzieci
     */
    children_ages?: number[];
    /**
     * idki standardów
     */
    room_standards?: number[];
    /**
     * idki ofert
     */
    offers?: number[];
    /**
     * Wyszukiwanie konkretnego pakietu
     */
    packet_id?: number;
    multi?: number[];

}